import React, { useState, useEffect, useContext } from "react";
import OffersTable from "./OffersTable";

function Issues() {
  return (
    <div className="Plans">
      <div className="main">
        <OffersTable />
      </div>
    </div>
  );
}

export default Issues;
